// extracted by mini-css-extract-plugin
module.exports = {"root":"TalentAnalysisToolTable_root__200GL","toolTableContainer":"TalentAnalysisToolTable_toolTableContainer__3PacA"};